var Utils = require('core-helpers/utils.js');
var PurchaseService = require('purchase/purchase-service.js');
var ExceptionService = require('exceptions/exception-service.js');
var Tracking = require('tracking/tracking-controller.js');

var ChooseYourPlan = (function (root, doc, undefined) {

    'use strict';

    var setPrice = function (price) {
        priceElement.innerHTML = priceElement.innerHTML + price;
        Utils.removeClass(priceElement, 'hide');
    };

    var onSuccess = function(response) {

        var cheapestPlan = PurchaseService.getCheapestPlan(response.plans);
        if(!cheapestPlan){
            return false;
        }

        let price = cheapestPlan.plan.monthlyPrice.humanFormats.symbol;
        if (cheapestPlan.hasOwnProperty('afterDiscountMonthlyPrice')) {
            price = cheapestPlan.afterDiscountMonthlyPrice.humanFormats.symbol;
        }

        if(price){
            setPrice(price);
        }

    };

    var getPrice = function(){
        PurchaseService.getPlans().then(onSuccess).done();
    };

    var init = function () {
        // Show price
        if(priceElement){
            getPrice();
        }
    };

    /**
     * Private vars
     */
    var filename = 'choose-your-plan.js';
    var priceElement = Utils.getById('premium-price');

    root.addEventListener('load', init);

})(window, document);
